// ------------------------------------
// Import SCSS files
// ------------------------------------
import "../sass/front-page.scss";

// ------------------------------------
// Scripts
// ------------------------------------

import "./components/header";
import "./components/slider";
import "./components/modals";